const OSS = require('ali-oss'); // 引入ali-oss依赖
